import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'components.payments.EditCounterpartyPaymentDetailsPopupContent.IncorrectInfoPopupContent',
    {
        title: 'Incorrect business type',
        differentBusinessType:
            'The details you entered are very similar to someone already on record, however the business type is different. Please check the information you have entered and click "Back" to update the business type if necessary, or click "Confirm" if you are sure the details are correct.',
        accountSwitched:
            'The details you entered are very similar to someone already on record. However the account has been switched to a different organisation. Please check the information you have entered and click "Back" to update the business type if necessary, or click "Confirm" if you are sure the details are correct.',
        name: 'Name',
        country: 'Country',
        currency: 'Currency',
        entityType: 'Entity Type',
        accountNumber: 'Account Number',
        sortCode: 'Sort Code',
        company: 'Company',
        individual: 'Individual',
        back: 'Back',
        confirm: 'Confirm',
    }
);
